import PropTypes from 'prop-types';
import { useEffect } from 'react';

export default function DynamicScriptLoader({ script, isAsync = false }) {
  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${script}"]`);
    if (existingScript) {
      return;
    }

    const newScript = document.createElement('script');
    newScript.src = script;
    newScript.async = isAsync;
    newScript.type = 'text/javascript';

    document.body.appendChild(newScript);
  }, [script, isAsync]);
  return null;
}

DynamicScriptLoader.propTypes = {
  script: PropTypes.string.isRequired,
  isAsync: PropTypes.bool,
};
